import React from 'react';
import classnames from 'classnames';
import { blindBuriedHole } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const BlindBuriedBias = (props) => {
  const name = 'blind_buried_hole';

  const {
    onChangeParameter,
    label,
    required,
    options,
    tooltip,
    parameters,
    groupName,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('silkscreen-sides', className)}
      disabled={disabled} />
  );
};

BlindBuriedBias.defaultProps = {
  label: Spree.translations.parameters.blind_buried_hole,
  options: blindBuriedHole,
  name: 'blind_buried_hole',
  tooltip: Spree.helpForParameters.blind_buried_hole,
};

export default BlindBuriedBias;
